import ddt from '@wix/da-ddt';
import { StreamType } from './types';
import * as offsetActions from './withOffset/actions';
import * as cursorActions from './withCursor/actions';
function getActionsForStreamType(type) {
    switch (type) {
        case StreamType.WITH_OFFSET:
            return offsetActions;
        case StreamType.WITH_CURSOR:
            return cursorActions;
        default:
            return {};
    }
}
function getFetchActionForDirection(actions, direction) {
    switch (direction) {
        case 'all':
            return actions.fetchAll;
        case 'prev':
            return actions.fetchPrevious;
        case 'next':
        default:
            return actions.fetch;
    }
}
export function getFetchActionForStreamType(type, direction) {
    var actions = getActionsForStreamType(type);
    var action = getFetchActionForDirection(actions, direction);
    if (!action) {
        ddt.warn('stream', 'Unknown stream type or action', type, direction);
        return function (streamId) {
            return ({ streamId: streamId, type: 'STREAM__UNKNOWN_TYPE__FETCH' });
        }; // no idea what this type is, noop
    }
    return action;
}
//# sourceMappingURL=helpers.js.map